import ExtendedContent from './ExtendeContent';

export default ExtendedContent;
